import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const InternalAdminIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M14.5569 11.6668c0-.1466-.02-.28-.04-.42l.76-.6733-.6667-1.15334-.9666.32667c-.2134-.18-.4534-.32-.72-.42l-.2-.99333h-1.3334l-.2.99333c-.2666.1-.5066.24-.72.42l-.96662-.32667-.66667 1.15334.76.6733c-.02.14-.04.2734-.04.42 0 .1467.02.28.04.42l-.76.6734.66667 1.1533.96662-.3267c.2134.18.4534.32.72.42l.2.9934h1.3334l.2-.9934c.2666-.1.5066-.24.72-.42l.9666.3267.6667-1.1533-.76-.6734c.02-.14.04-.2733.04-.42Zm-2.5 1.3334c-.7333 0-1.3333-.6-1.3333-1.3334 0-.7333.6-1.3333 1.3333-1.3333s1.3333.6 1.3333 1.3333c0 .7334-.6 1.3334-1.3333 1.3334Z" />
    <path
      fillRule="evenodd"
      d="M.666504 1.3335H7.33317v2.66666h6.66663V7.3335h-1.3333v-2H7.33317v6.6667h.96101v1.3333H.666504v-12ZM1.99984 12.0002h4v-1.3334h-4v1.3334Zm0-2.6667h4V8.00016h-4V9.3335Zm0-2.66667h4V5.3335h-4v1.33333Zm0-2.66667h4V2.66683h-4v1.33333Z"
      clipRule="evenodd"
    />
    <path d="M8.6665 6.66683h2.6667v1.33333H8.6665V6.66683Z" />
  </Icon>
);

export default memo(InternalAdminIcon);
